<template>
  <div style="width: 100%; height: 100%;">
    <!--
    <html>
      <head>
      </head>
      <body>
    -->
    <div ref="reports">
      <div v-for="report in reports" :key="report.machine.id">
        <div class="page" style="margin-bottom: 50px;">
          <span style="width:100%; text-align:center;"><h2>SUPERVISORY SUMMARY REPORT {{formatDate(report.fromDate)}} - {{formatDate(report.toDate)}}</h2></span><br/>
          <br/>
          Machine ID: {{ report.machine.id }}<br/>
          Machine Description: {{ report.machine.name }} - {{ report.machine.location }}<br/>
          Date: {{ report.date }} UTC<br/> <!-- |date("Y-m-d H:i") -->
          <br/>
          <hr>
          <br/>
          <div v-if="!hasData(report)">
            No Data
          </div>
          <div v-else>
            <p>
              Number of Loads: {{ report.totals.loads }}<br/>
              <!-- Number of Cycle Interrupts: {{ report.totals.cycle_int }}<br/> -->
            </p>
            <p>
              Total Film Weight: {{ report.totals.film_weight|round(1) }} {{ units.ounces }}<br/>
              Total Unwind Length: {{ report.totals.unwind_length|round(1) }} {{ units.feet }}<br/>
              Total Film Cost: {{ report.totals.film_cost|round(2) }}<br/>
            </p>
            <p>
              Total Wrap Time: {{formatInterval(report.totals.wrap_time || 0)}}<br />
              Average Wrap Time: {{formatInterval(report.totals.wrap_time_avg || 0)}}<br />
              Average Idle Time: {{formatInterval(report.totals.wrap_time_avg_idle || 0)}}<br />
            </p>
            <br/>
            <hr>
            <br/>
            <p><b>Applied Stretch Statistics</b></p>
            Average Applied Stretch: {{ report.totals.stretch_pct_avg|round(1) }}%<br/>
            High Applied Stretch: {{ report.totals.stretch_pct_max|round(1) }}%<br/>
            Low Applied Stretch: {{ report.totals.stretch_pct_min|round(1) }}%<br/>
            Standard Deviation: {{ report.totals.std_deviation|round(1) }}%<br /><!-- sqrt necessary? -->
            <br/>
            <hr>
            <br/>
            <p><b>Number of Alarms</b></p>
            Applied Stretch Alarms: {{ report.totals.alarm_stretch }}<br/>
            Revolution Alarms: {{ report.totals.alarm_revolution }}<br/>
            Unwind Length Alarms: {{ report.totals.alarm_unwind_length }}<br/>
            <br/>
            <hr>
            <br/>
            <p><b>Estimated Cost of Non-Target Stretch Wrapping</b></p>
            Estimated Cost: ${{ report.totals.non_target_cost }}<br />
            <br/>
            <hr>
            <br/>
            For support on this report, please contact portal support at:<br/>
            Email: portalsupport@highlightindustries.com<br/>
            Tel: 1.800.531.2465<br/>
          </div>
        </div>
      </div>
      <!--
      </body>
      </html>
      -->
    </div>
    <iframe v-show="false" id="report" ref="frame" src="javascript:void(0);" style="width: 100%; height: 100%;" frameborder="0"></iframe>
  </div>
</template>

<script>
import jQuery from 'jquery'
import get from 'lodash/get'
import moment from 'moment'

let units = {
  '1': { // Imperial
    feet: 'ft',
    gauge: 'Ga',
    inches: 'in',
    ounces: 'oz'
  },
  '2': { // Metric
    feet: 'm', // meters
    gauge: 'μm', // microns
    inches: 'mm', // millimeters
    ounces: 'g' // grams
  }
}
export default {
  props: {
    reports: {
      type: Array
    }
  },
  data () {
    return {
      units: units['1']
    }
  },
  filters: {
    round (value, length = 1) {
      return Math.round(value * Math.pow(10, length)) / Math.pow(10, length)
    }
  },
  mounted () {
    jQuery(this.$refs.frame).contents().find('html').html('<style>.page {width: 100%;page-break-after: always;}</style>' + jQuery(this.$refs.reports).html())
  },
  methods: {
    formatInterval (s) {
      let negative = s < 0
      s = Math.abs(s)
      let f = Math.floor
      let g = (n) => ('00' + n).slice(-2)
      return (negative ? '-' : '') + f(s / 3600) + ':' + g(f(s / 60) % 60) + ':' + g(s % 60)
    },
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD') + ' (AT ' + moment(date).format('HH:mm:ss') + ')'
    },
    hasData (report) {
      return get(report, 'totals') && !(Array.isArray(report.totals) && !report.totals.length)
    },
    print () {
      console.log('frame', this.$refs.frame)
      this.$refs.frame.focus()
      this.$refs.frame.contentWindow.print()
    }
  }
}
</script>
